import React from "react";
import { Link, useLocation } from "react-router-dom";

function formatCurrency(value) {
  return new Intl.NumberFormat("id-ID", {
    style: "currency",
    currency: "IDR",
    maximumFractionDigits: 0,
  }).format(Number(value || 0));
}

export default function OrderSuccess() {
  const location = useLocation();

  const orderCode = location.state?.orderCode || "-";
  const customerName = location.state?.customerName || "Pelanggan";
  const totalAmount = location.state?.totalAmount || 0;

  return (
    <div className="min-h-screen bg-gray-50 px-4 py-12 dark:bg-gray-900">
      <div className="mx-auto max-w-2xl rounded-2xl border border-gray-200 bg-white p-8 text-center shadow-sm dark:border-gray-700 dark:bg-gray-800">
        <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-green-100 text-2xl dark:bg-green-900/30">
          ✅
        </div>

        <h1 className="mt-6 text-3xl font-bold text-gray-900 dark:text-white">
          Pesanan Berhasil Dibuat
        </h1>

        <p className="mt-3 text-gray-600 dark:text-gray-300">
          Terima kasih, {customerName}. Pesanan Anda sudah masuk ke sistem.
        </p>

        <div className="mt-8 rounded-2xl border border-gray-200 bg-gray-50 p-6 text-left dark:border-gray-700 dark:bg-gray-900">
          <div className="flex items-center justify-between border-b border-gray-200 py-3 dark:border-gray-700">
            <span className="text-sm text-gray-500 dark:text-gray-400">
              Kode Order
            </span>
            <span className="font-semibold text-gray-900 dark:text-white">
              {orderCode}
            </span>
          </div>

          <div className="flex items-center justify-between py-3">
            <span className="text-sm text-gray-500 dark:text-gray-400">
              Total Pembayaran
            </span>
            <span className="font-semibold text-gray-900 dark:text-white">
              {formatCurrency(totalAmount)}
            </span>
          </div>
        </div>

        <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:justify-center">
          <Link
            to="/marketplace"
            className="rounded-xl bg-gray-900 px-5 py-3 text-sm font-semibold text-white hover:bg-gray-800 dark:bg-white dark:text-gray-900 dark:hover:bg-gray-200"
          >
            Kembali ke Marketplace
          </Link>

          <Link
            to="/"
            className="rounded-xl border border-gray-300 px-5 py-3 text-sm font-semibold text-gray-700 hover:bg-gray-100 dark:border-gray-600 dark:text-gray-200 dark:hover:bg-gray-700"
          >
            Ke Home
          </Link>
        </div>
      </div>
    </div>
  );
}